// Deprecated. Please refrain from new usage
import Scrollbar from "react-scrollbars-custom";
import React, { useState } from "react";
import { withTheme } from "@material-ui/core";
import PropTypes from "prop-types";
import ScrollFadeIndicator from "./ScrollFadeIndicator";

export const SPScrollbar = ({ style, children, horizontalOnly, ...props }) => {
  const calculatedStyle = {
    height: "100%",
    width: "100%",
    ...style,
  };

  const [scrollPosition, setScrollPosition] = useState({
    // arbitrary values that get overwritten immediately, but they are needed for consistency
    scrollLeft: 0,
    clientWidth: 999,
    scrollWidth: 10000,
  });

  const handleScroll = (e) => {
    setScrollPosition(e);
  };

  const { clientWidth, scrollLeft, scrollWidth } = scrollPosition;
  return (
    <div
      style={{
        ...calculatedStyle,
        position: "relative",
        overflow: "hidden",
        display: "flex",
      }}
    >
      <Scrollbar style={calculatedStyle} onScroll={handleScroll} {...props}>
        {children}
      </Scrollbar>
      {horizontalOnly && scrollLeft > 0 && <ScrollFadeIndicator direction="left" />}

      {horizontalOnly && scrollLeft < scrollWidth - clientWidth && (
        <ScrollFadeIndicator direction="right" />
      )}
    </div>
  );
};

SPScrollbar.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  theme: PropTypes.object.isRequired,
  trackYProps: PropTypes.object,
  thumbYProps: PropTypes.object,
  onScrollStop: PropTypes.func,
  horizontalOnly: PropTypes.bool,
};

SPScrollbar.defaultProps = {
  style: {},
  trackYProps: {
    style: {
      background: "#2B3141",
    },
  },
  thumbYProps: {
    style: {
      background: "#4F576C",
    },
  },
  onScrollStop: null,
  horizontalOnly: false,
};

export default withTheme(SPScrollbar);
